import React from "react";
import { useDispatch } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import actions from "../../Store/actions";
import { strings } from "../i18n";
import config from "../../config";
import useBranding from "../hooks/use-branding";

const CLICK_COUNT = 3;

type Props = {
    height: number,
    light: boolean
};

/**
 * Logo Component
 * @param {Props} props
 */
const Logo = ({ height = 64, light = false }: Props) => {
    const branding = useBranding().image;

    const styles = () => ({
        logo: {
            backgroundImage: `url(${branding.menuLogo})`,
            backgroundPosition: "left",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            width: "100%",
            height: ({ height }) => height
        }
    });
    const classes = makeStyles(styles)({ height, light });
    const [clicks, setClicks] = React.useState(0);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (clicks >= CLICK_COUNT) {
            dispatch(
                actions.toast.create.info(
                    `${strings("version")} ${config.version}`
                )
            );
            setClicks(0);
        }
    }, [clicks]);

    const onClick = () => setClicks(clicks + 1);

    return <div className={classes.logo} onClick={onClick} />;
};

export default Logo;
